import { AnimatePresence } from "framer-motion";
import { useContext, useEffect, useMemo, useState } from "react";
import CloseIcon from "../../components/CloseIcon/CloseIcon.js";
import CustomButtonV2 from "../../components/CustomButtonV2/CustomButtonV2.js";
import HeaderCadastro from "../../components/HeaderCadastro/HeaderCadastro.js";
import ModalConfirmacao from "../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../components/ModalUsuario/ModalUsuario.tsx";
import TabelaV2 from "../../components/TabelaV2/TabelaV2";
import ToastErro from "../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { useProfile } from "../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../contexts/RequestController";
import TabelaRedux from "../../contexts/Tabela";
import MotionContainer from "../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../core/components/MotionSemAutorizacao.tsx";
import Separator from "../../core/components/Separator.tsx";
import Layout from "../../core/layout/Layout.tsx";
import {
	cadastraGrupoPrecificacao,
	deleteGrupoPrecificacaoPorId,
	editaGrupoPrecificacaoPorId,
	getGrupoPrecificacao,
	getGrupoPrecificacaoPorId,
} from "../../services/ModuloGerenciador/GrupoPrecificacao";
import "./GrupoPrecificacao.css";

function GrupoPrecificacao(props) {
	const { profile, hasRegra, tabelaEmpresa } = useProfile();

	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState([]);

	const [validator, setValidator] = useState([]);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const buscarGrupoPrecificacao = async () => {
		setLoading(true);
		await getGrupoPrecificacao(profile?.token)
			.then((result) => {
				setDadosTabela(result.data);
				setTabelaRedux({});
				setTimeout(() => {
					setLoading(false);
				}, 1000);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const cadastrar = async () => {
		if (values.nome !== "" && validator.nome === "true") {
			setLoading(true);
			await cadastraGrupoPrecificacao(values, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						buscarGrupoPrecificacao();
						setDadosRequestControllerRedux("Fechar Modal GrupoPrecificacao");
						setTabelaRedux({});
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else {
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
			setLoading(false);
		}
	};

	const editar = async () => {
		setLoading(true);
		await editaGrupoPrecificacaoPorId(values, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarGrupoPrecificacao();
					setTabelaRedux({});
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarGrupoPrecificacaoPorId = async () => {
		setLoading(true);
		await getGrupoPrecificacaoPorId(
			tabelaRedux.colunaSelecionada,
			profile?.token
		)
			.then((result) => {
				if (result.status === 200) {
					if (editando) {
						setValues(result.data);
						setLoading(false);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const title = useMemo(() => {
		if (editando) return "Detalhes de Grupo Precificação";
		if (telaCadastro) return "Cadastro de Grupo Precificação";
		return "Grupo de Precificação";
	}, [editando, telaCadastro]);

	const buscarGrupoPrecificacaoPorIdModal = async (id) => {
		setLoading(true);
		await getGrupoPrecificacaoPorId(id, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					setValues(result.data);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const deletarGrupoPrecificacaoPorId = async () => {
		setLoading(true);
		await deleteGrupoPrecificacaoPorId(
			tabelaRedux.colunaSelecionada,
			profile?.token
		)
			.then((result) => {
				if (result.status === 200) {
					buscarGrupoPrecificacao();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		if (editando && profile?.token) {
			buscarGrupoPrecificacaoPorId();
		}
	}, [editando, profile?.token]);

	useEffect(() => {
		if (props.idAtual && profile?.token) {
			buscarGrupoPrecificacaoPorIdModal(props.idAtual);
		}
	}, [props.idAtual, profile?.token]);

	useEffect(() => {
		if (props.telaCadastro === true) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Precificação"));
			buscarGrupoPrecificacao();
		}
	}, [profile?.token, hasRegra]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title={title} showNavbar={props.navbar}>
			<AnimatePresence mode="wait">
				{!telaCadastro ? (
					<MotionContainer key="GrupoPrecificacaoContainer">
						<div className="content-container">
							<Separator size="xl" />
							<TabelaV2
								setTelaCadastro={setTelaCadastro}
								setEditando={setEditando}
								classeSelecionado="idPrecificacao"
								nomeClasse1="outer-wrapper-v2"
								nomeClasse2="table-v2-center"
								colunas={tabelaEmpresa.GrupoPrecificacao}
								dados={dadosTabela}
								isLoading={loading}
							/>
						</div>
						<div className="footer-container">
							<div>
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Cadastrar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setTelaCadastro(true);
										setEditando(false);
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-editar"
									classText="button-texto-editar"
									titulo="Editar"
									icone="iconeEdit"
									cor="#CDCDCD"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setTelaCadastro(true);
											setEditando(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-deletar"
									classText="button-texto-cadastrar"
									titulo="Deletar"
									icone="iconeDelete"
									cor="#DC2D2D"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setOpen(true);
											setTextoSucesso("Deletado Com Sucesso");
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
							<div>
								<CustomButtonV2
									classCss="custom-button-user"
									classText="button-texto-user"
									titulo="Obter Usuário"
									cor="#FFFFFF"
									valor={values}
									onClick={() => {
										if (tabelaRedux.usuarioAlteracao) {
											setOpenUsuario(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
						</div>
					</MotionContainer>
				) : (
					<MotionContainer key="GrupoPrecificacaoCadastroContainer">
						<div className="content-container">
							{!props.desabilitar && (
								<div className="texto-cadastro-container">
									{props.botaoFechar !== false && (
										<div style={{ width: 29, height: 29 }} />
									)}
									<div className="texto-cadastro">
										<p className="indicador-emb">
											{"Dados de Grupo Precificação /"}
										</p>
										{editando ? (
											<p className="indicador-emb">
												{"Detalhes de Grupo Precificação"}
											</p>
										) : (
											<p className="indicador-emb">
												{"Cadastro de Grupo Precificação"}
											</p>
										)}
										<HeaderCadastro texto="" />
									</div>
									{props.botaoFechar !== false && (
										<div className="close-btn">
											<CloseIcon
												onClick={() => {
													setValues({});
													setTelaCadastro(false);
													setEditando(false);
													setTabelaRedux({});
												}}
											/>
										</div>
									)}
								</div>
							)}
							<div className="flex-column">
								<div className="container-select-emb">
									<div className="rota-div-2">
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Nome:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															nome: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															nome: "true",
														}));
													}}
													placeholder="Ex: Grupo 1"
													value={values.nome}
													disabled={props.desabilitar}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="footer-container">
							{editando ? (
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Salvar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										editar();
										setTelaCadastro(false);
										setEditando(false);
										setValues({});
									}}
								/>
							) : (
								<>
									{!props.desabilitar ? (
										props.botaoCadastrar ? (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													if (values.nome !== "" && validator.nome === "true") {
														cadastrar();
														setValues({});
													} else {
														setTextoErro("Há campos sem preencher!");
														setOpenToastErro(true);
													}
												}}
											/>
										) : (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													if (values.nome !== "" && validator.nome === "true") {
														cadastrar();
														setValues({});
														setTelaCadastro(false);
													} else {
														setTextoErro("Há campos sem preencher!");
														setOpenToastErro(true);
													}
												}}
											/>
										)
									) : (
										<></>
									)}
								</>
							)}
							{props.botaoVoltar ? (
								<></>
							) : (
								<CustomButtonV2
									classCss="custom-button-cancelar"
									classText="button-texto-cancelar"
									titulo="Cancelar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setValues({});
										setTelaCadastro(false);
										setEditando(false);
										setTabelaRedux({});
									}}
								/>
							)}
						</div>
					</MotionContainer>
				)}
			</AnimatePresence>
			<ModalConfirmacao
				titulo="Deletar"
				texto="Deseja Deletar?"
				tituloConfirmar="Confirmar"
				tituloCancelar="Cancelar"
				open={open}
				onClose={handleClose}
				onClick={deletarGrupoPrecificacaoPorId}
			/>
			<ModalUsuario
				titulo="Usuário"
				tituloConfirmar="OK"
				open={openUsuario}
				onClose={handleCloseUsuario}
			/>
			<ToastSucesso
				texto={textoSucesso}
				open={openToastSucesso}
				onClose={handleCloseToastSucesso}
			/>
			<ToastErro
				texto={textoErro}
				open={openToastErro}
				onClose={handleCloseToastErro}
			/>
		</Layout>
	);
}

export default GrupoPrecificacao;
